import { IconProp } from "@fortawesome/fontawesome-svg-core";
import { faCartShopping, faTruck } from "@fortawesome/pro-regular-svg-icons";

export enum CslType {
    CUSTOMER = "CUSTOMER",
    SUPPLIER = "SUPPLIER",
    BOTH = "BOTH"
}

export const cslTypeIcons: { [key in CslType]: IconProp } = {
    [CslType.CUSTOMER]: faCartShopping,
    [CslType.SUPPLIER]: faTruck,
    [CslType.BOTH]: faCartShopping
};

export enum CslFeedbackType {
    SUCCESS = "SUCCESS",
    ERROR = "ERROR"
}
